import React from "react";
import { Button, Stack } from "@mui/material";
import { SubmitOptions } from "../../../types";
import { DeskingTestIds } from "../../../constants";

interface Props {
  isProposalLoading: boolean;
  onSubmitForm: (options: SubmitOptions) => Promise<void>;
}

export const PanelFormActions = ({ onSubmitForm, isProposalLoading }: Props) => (
  <Stack direction="row" gap="0.5rem" data-testid={DeskingTestIds.PanelFormActions}>
    <Button variant="contained" loading={isProposalLoading} onClick={() => onSubmitForm({ isDraft: false })}>
      Send
    </Button>

    <Button loading={isProposalLoading} onClick={() => onSubmitForm({ isDraft: true })}>
      Save as draft
    </Button>
  </Stack>
);
